import { useState } from "react";
import { EMPTY_FILTER, openStatuses, groupByTeam } from "./view";

export default function FilterBar({ filter, onChange, meta, staff }) {
    const [open, setOpen] = useState(false); // 모바일에서 필터 펼침
    const set = (patch) => onChange({ ...filter, ...patch });
    const current = filter.statuses ?? openStatuses(meta);
    const toggleStatus = (code) =>
        set({ statuses: current.includes(code) ? current.filter((s) => s !== code) : [...current, code] });
    return (
        <>
            <div className="mfilter">
                <button className="btn btn-sm" onClick={() => setOpen(!open)}><i className="fa-solid fa-filter"></i>필터</button>
                <span style={{ fontSize: 12, color: "var(--tx2)" }}>기본: 접수 · 처리중 · 보류</span>
            </div>
            <div className={`filters ${open ? "open" : ""}`}>
                <div className="fg"><label>경로</label>
                    <div className="seg">
                        {[{ code: "all", label: "전체" }, ...(meta?.channels || [])].map((c) => (
                            <button key={c.code} className={filter.channel === c.code ? "on" : ""} onClick={() => set({ channel: c.code })}>{c.label}</button>
                        ))}
                    </div>
                </div>
                <div className="fg"><label>진행상태</label>
                    <span style={{ display: "flex", gap: 10 }}>
                        {(meta?.statuses || []).map((s) => (
                            <label key={s.code} className="chk">
                                <input type="checkbox" checked={current.includes(s.code)} onChange={() => toggleStatus(s.code)} />{s.label}
                            </label>
                        ))}
                    </span>
                </div>
                <div className="fg"><label htmlFor="inq-f-category">구분</label>
                    <select id="inq-f-category" className="sel" value={filter.category} onChange={(e) => set({ category: e.target.value })}>
                        <option value="">전체</option>
                        {(meta?.categories || []).map((c) => <option key={c.code} value={c.code}>{c.label}</option>)}
                    </select>
                </div>
                <div className="fg"><label htmlFor="inq-f-assignee">담당자</label>
                    <select id="inq-f-assignee" className="sel" value={String(filter.assignee)} onChange={(e) => set({ assignee: e.target.value })}>
                        <option value="">전체</option>
                        <option value="none">미지정</option>
                        {groupByTeam(staff).map((g) => (
                            <optgroup key={g.team} label={g.team}>
                                {g.members.map((s) => <option key={s.id} value={String(s.id)}>{s.name}{s.active ? "" : " (사용 중지)"}</option>)}
                            </optgroup>
                        ))}
                    </select>
                </div>
                <div className="fg"><label>등록일</label>
                    <input type="date" className="inp" aria-label="등록일 시작" value={filter.from} onChange={(e) => set({ from: e.target.value })} />
                    <span style={{ color: "var(--tx3)" }}>~</span>
                    <input type="date" className="inp" aria-label="등록일 끝" value={filter.to} onChange={(e) => set({ to: e.target.value })} />
                </div>
                <div className="fg">
                    <input className="inp fq" placeholder="상호명 · 사업자번호 · 요청 내용" value={filter.q} onChange={(e) => set({ q: e.target.value })} />
                </div>
                <button className="btn btn-sm btn-ghost" onClick={() => onChange(EMPTY_FILTER)}>
                    <i className="fa-solid fa-rotate-left"></i>초기화
                </button>
            </div>
        </>
    );
}
